// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WQcAaTeMRInriVCOdV_N{text-decoration:underline}.YB9IbdFnYWq6okQIltqj{margin-left:5px;font-weight:300;font-size:12px}`, "",{"version":3,"sources":["webpack://./../@depmap/common-components/src/styles/ExternalLink.scss"],"names":[],"mappings":"AAAA,sBACE,yBAAA,CAGF,sBACE,eAAA,CACA,eAAA,CACA,cAAA","sourcesContent":[".ExternalLink {\n  text-decoration: underline;\n}\n\n.externalLinkIcon {\n  margin-left: 5px;\n  font-weight: 300;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ExternalLink": `WQcAaTeMRInriVCOdV_N`,
	"externalLinkIcon": `YB9IbdFnYWq6okQIltqj`
};
export default ___CSS_LOADER_EXPORT___;
